import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentofdividentService {

  constructor( private httpService: HttpService) { }


    samplePodRecord(object) {
        console.log("object", object);
        // return this.http.post(environment.pssUrl + 'Investment/ecsEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
        //         .map(res => res.json());
        var request = {
            URL: "paymentOfDividend/podEntry",
            DATA: object
        }
        return this.httpService.post(request);
    }

    getRegisterDirector(object) {
        var registerList = {
            URL: "paymentOfDividend/getPaymentDetails/5cee33d225242e023acfb2d4",
            DATA: object
        }
        return this.httpService.post(registerList);
    }

    removePaymentOfDividenddetails(_id) {
        var request = {
            URL: "paymentOfDividend/deletedetails/" + _id
        }
        return this.httpService.get(request);
    }

    updatePayment(_id) {
        var editlist = {
            URL: "paymentOfDividend/update/" + _id,
        }
        return this.httpService.get(editlist);
    }

    updateBankAccountParticulars(object, id) {
        var request = {
            URL: "paymentOfDividend/updatePaymentOfDividend/" + id,
            DATA: object
        }
        return this.httpService.post(request);
    }

    generatePaymentOfDividendDocument(object) {
        var request = {
            URL: "paymentOfDividend/generatePaymentOfDividendDocument",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadPaymentOfDividendFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "paymentOfDividend/downloadDocument/" + id + "/" + type + "/" + token;
    }

    downloadPaymentOfDividendPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "paymentOfDividend/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }

}